import { Field, Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import * as Yup from 'yup';
import BackBtn from '../../../components/UI/BackButton/BackButton';
import Button from '../../../components/UI/Button/CustomButton';
import CurrencyFormat from '../../../components/UI/Form/NumberFormat/CurrencyFormat';
import { COAPP_GROSS_ANNUAL_INCOME_TOOLTIP_TEXT } from '../../../constants/tooltipTexts';
import { reactGAEvent, reactGAPageview } from '../../../helper';
import { changePage, changeEnerBankInfoValue, submitMindfire } from '../../../redux/actions/index';
import { EnerBankFlowPageNumber } from './EnerBankFlow';

const CoAppIdentificationInfo = props => {
  const {
    email,
    dispatchChangePage,
    dispatchChangeInfoValue,
    information,
    children,
    dispatchSubmitMindfire,
    did,
    dealerUserId,
    isReview,
  } = props;

  useEffect(() => {
    reactGAPageview({
      path: '/ca_ebcoappincome',
      trackerNames: [],
      title: 'ca_ebcoappincome',
      dealerUserId,
      did,
    });
    // eslint-disable-next-line
  }, []);

  const changeValues = values => {
    dispatchChangeInfoValue('coAppGrossAnnualIncome', values.coAppGrossAnnualIncome);
  };

  const CoAppIdentificationInfoForm = ({ values }) => (
    <Form>
      <Field
        component={CurrencyFormat}
        label="Total Annual Income"
        name="coAppGrossAnnualIncome"
        id="coAppGrossAnnualIncome"
        tooltipText={COAPP_GROSS_ANNUAL_INCOME_TOOLTIP_TEXT}
        type="text"
      />
      <Button type="submit" title={isReview ? 'Review' : 'Next'} />
    </Form>
  );

  const CoAppIdentificationInfoFormFormik = withFormik({
    mapPropsToValues: () => ({
      coAppGrossAnnualIncome: information.coAppGrossAnnualIncome || '',
    }),

    validationSchema: Yup.object({
      coAppGrossAnnualIncome: Yup.number()
        .moreThan(-1, 'Please enter a positive number.')
        .required('Please enter Total Annual Income.'),
    }),

    handleSubmit: values => {
      reactGAEvent({
        category: 'Button',
        action: 'Click',
        label: 'Next',
        did: did,
        dealerUserId: dealerUserId,
      });
      changeValues(values);
      dispatchChangePage(EnerBankFlowPageNumber.ApplicationReview);
      dispatchSubmitMindfire({
        email: email,
        company: values.coAppEmployerName,
        lastPage: '11020',
        dealerUserId: dealerUserId,
        did: did,
      });
    },
  })(CoAppIdentificationInfoForm);

  return (
    <Container>
      <Row>
        <BackBtn
          changePage={dispatchChangePage}
          page={
            isReview
              ? EnerBankFlowPageNumber.ApplicationReview
              : EnerBankFlowPageNumber.CoAppIdentificationInfo
          }
        />
        <Col sm="5">{children}</Col>
        <Col sm="6">
          <CoAppIdentificationInfoFormFormik />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => ({
  information: state.enerBankInformation,
  email: state.preQualificationInformation.email,
  dealerUserId: state.auth.dealerUserId,
  did: state.auth.did,
  isReview: state.enerBankInformation.isReview,
});

const mapDispatchToProps = dispatch => ({
  dispatchChangePage: page => dispatch(changePage(page)),
  dispatchChangeInfoValue: (key, value) => dispatch(changeEnerBankInfoValue(key, value)),
  dispatchSubmitMindfire: params => dispatch(submitMindfire(params)),
});

CoAppIdentificationInfo.propTypes = {
  information: PropTypes.object,
  dispatchChangePage: PropTypes.func,
  dispatchChangeEnerBankInfoValue: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CoAppIdentificationInfo);
